import { SvgComponentProps } from "@/src/types/SVGPropType";
import * as React from "react";
const CheckPremiumSVG: React.FC<SvgComponentProps> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={21}
    height={15}
    fill="none"
    {...props}
  >
    <path
      fill="#FEC5FB"
      fillRule="evenodd"
      d="M7.619 14.38 20.113 1.887 18.98.755 7.618 12.116 2.023 6.521.891 7.653l6.727 6.727Z"
      clipRule="evenodd"
    />
  </svg>
);
export default CheckPremiumSVG;
